// src/app/shared/global-payments-logo/global-payments-logo.component.ts
import { Component, Input } from '@angular/core';
import { LucideAngularModule, Globe } from 'lucide-angular';

@Component({
  selector: 'app-global-payments-logo',
  standalone: true,
  imports: [LucideAngularModule],
  template: `
    <div class="flex items-center gap-2" [class]="variant === 'light' ? 'text-white' : 'text-gray-800'">
      <div class="relative">
        <lucide-icon [img]="Globe" [size]="size === 'sm' ? 20 : 26" />
      </div>
      <div class="flex flex-col leading-none">
        <span [class]="'font-bold tracking-tight ' + (size === 'sm' ? 'text-sm' : 'text-lg')">
          Global Payments
        </span>
        @if (size === 'md') {
          <span class="text-[10px] font-medium tracking-widest uppercase opacity-60">
            Merchant Hub
          </span>
        }
      </div>
    </div>
  `,
})
export class GlobalPaymentsLogoComponent {
  @Input() variant: 'light' | 'dark' = 'dark';
  @Input() size: 'sm' | 'md' = 'md';

  readonly Globe = Globe;
}
